<template>
  <section class="section dark" id="schedule" style="position: relative">
    <div class="schedule-pattern"></div>
    <div class="wrap" style="position: relative">
      <div class="section-head">
        <div>
          <div class="eyebrow-line">Viernes 2 octubre 2026</div>
          <h2>RECOGIDA DE DORSALES.</h2>
        </div>
        <p class="intro-text">
          Recoge tu dorsal el día antes en el
          <a href="https://gimnascanostra.com/"
             target="_blank"
             style="color: #fff; font-weight: bold">Gimnàs Ca Nostra</a>,
          <strong style="color: #fff">de 16:00 a 21:00 h</strong>.
        </p>
      </div>

      <div class="section-head">
        <div>
          <div class="eyebrow-line">Sábado 3 octubre 2026</div>
          <h2>DÍA DE CARRERA.</h2>
        </div>
        <p class="intro-text">
          Dos bloques: <strong style="color: #fff">Open por la mañana</strong>,
          <strong style="color: #fff">Pro por la tarde</strong>.
          Los horarios de salida se confeccionarán según las parejas inscritas.
        </p>
      </div>

      <div class="schedule-scroll">

      <table class="schedule">
        <thead>
          <tr>
            <th>Hora</th>
            <th>Acto</th>
            <th style="text-align: right">Bloque</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="time">08:00</td>
            <td>Apertura de la carpa</td>
            <td class="tag"><TagPill variant="muted">TODOS</TagPill></td>
          </tr>
          <tr>
            <td class="time">09:00</td>
            <td>Comienzo del bloque Open · Salidas escalonadas</td>
            <td class="tag"><TagPill>OPEN</TagPill></td>
          </tr>
          <tr>
            <td class="time">14:00</td>
            <td>Comienzo del bloque Pro · Salidas escalonadas</td>
            <td class="tag"><TagPill>PRO</TagPill></td>
          </tr>
          <tr>
            <td class="time">19:00</td>
            <td>Podio · Plaça des Born</td>
            <td class="tag"><TagPill variant="muted">CEREMONIA</TagPill></td>
          </tr>
          <tr>
            <td class="time">20:00</td>
            <td>Sorteos post-competición &amp; cierre</td>
            <td class="tag"><TagPill variant="muted">SOCIAL</TagPill></td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>
  </section>
</template>

<script setup>
import TagPill from './ui/TagPill.vue'
</script>

<style scoped>
.schedule-pattern {
  position: absolute;
  inset: 0;
  background: url("~@/assets/patterns/pattern.png") center / 280px;
  opacity: 0.05;
  pointer-events: none;
}
.intro-text {
  max-width: 380px;
  color: rgba(255,255,255,0.7);
  margin: 0;
  font-size: 16px;
  line-height: 1.55;
}
</style>
